import { EMetricBlockName, EMetricItemType } from "../types";
import { getClearText } from "../utils";
export var getMetricSearchBlockData = function getMetricSearchBlockData(_ref) {
  var data = _ref.data,
    action = _ref.action,
    isEvery = _ref.isEvery,
    query = _ref.query;
  var parsedData = JSON.parse(data);
  var blockName = parsedData === null || parsedData === void 0 ? void 0 : parsedData.block_name;
  var isNotResultBlocks = !!blockName && blockName === EMetricBlockName.recommendations || blockName === EMetricBlockName.keywords;
  var metric = {
    action: action
  };
  if (isNotResultBlocks) {
    metric.block_name = blockName;
    metric.item_type = EMetricItemType.block;
    if (isEvery) {
      metric.element_title = parsedData.title;
      metric.item_type = EMetricItemType.element;
    }
  } else {
    metric.item_type = EMetricItemType.element;
    metric.element_type = parsedData === null || parsedData === void 0 ? void 0 : parsedData.element_type;
    metric.field_text = query;
    metric.element_title = parsedData.title;
  }
  return metric;
};
export var getMetricSearchBannerData = function getMetricSearchBannerData(data, action) {
  var parseData = JSON.parse(data);
  return {
    action: action,
    item_type: EMetricItemType.banner,
    banner_title: getClearText(parseData.title),
    banner_url: parseData.url,
    banner_id: parseData.title,
    banner_type: 'static',
    banner_position: 'bottom',
    banner_campId: null
  };
};
export var getMetricEcommerceData = function getMetricEcommerceData(data) {
  var parseData = JSON.parse(data);
  return [{
    id: parseData.id,
    name: parseData.title,
    list: 'search',
    category: parseData.category,
    brand: parseData.brand,
    price: parseData.price
  }];
};